import {getCurrentCaption, divideCaption} from './CaptionProcessor';
import applyCapitalizationToCaption from './TextCapitalization';
import {getCurrentLines, getHighlightText} from './TextProcessingStrategy';
import {wrapTextRegular, wrapTextWordByWord} from './TextWrapper';
import {getTimedWords, getCurrentWord} from './WordTimingProcessor';

export type * from './types';

export const TextProcessing = {
  divideCaption,
  getCurrentCaption,
  wrapTextRegular,
  wrapTextWordByWord,
  applyCapitalizationToCaption,
  getTimedWords,
  getCurrentWord,
  getCurrentLines,
  getHighlightText,
} as const;
